<!-- 教师评价列表 -->
<template>
    <div class="el-TeacherEvaluateView">
        <el-row class="page_content">
            <h1 class="head_title">教师评价</h1>
            {{dataInfo}}
        </el-row>
    </div>
</template>
<script>
export default {
  name: "TeacherEvaluateView",
  data() {
    return {
        id:this.$route.query.idInfo, //id
        dataInfo:{}
    };
  },
  created() {
        if(this.$isEmpty(this.id)){
            this.$message.warning("数据丢失！");
            return;
        }
        this.getInfo();
  },
  methods: {
    getInfo(){ //获取信息
      this.$store.dispatch("user/getTeacherEvaluate",{teacherEvaluateId:this.id}).then((ret) => {
        if (ret.code === 0 || ret.code === '0') {
          this.dataInfo = ret.data;
        } else {
          this.$message({
             message: ret.msg,
             type: 'warning'
          });
        }
      })
    },
    selectScore(v){
      this.getSurveyList();
    },
    selectData(item){ //立即填写或者查看
        this.$router.push({name: 'TeacherEvaluateView', query: { idInfo: item.teaEvaluateId }});
    }
  }
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-TeacherEvaluateView{
    .wd{
        color: @red;
    }
    .el-dialog__body{
        border-top:1px solid #ebeef5;
    }
    .el-descriptions-item__container{
        font-size: 17px;
    }
    .el-descriptions-item__label {
        white-space: nowrap;
        width: 140px;
        text-align: right;
    }
    .el-descriptions-item__content{
        max-height: 200px;
        overflow: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/teacherEvaluate/TeacherEvaluateView.vue